import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-plus",
  templateUrl: "./med-icon-plus.component.html",
})
export class MedIconPlusComponent extends SvgMixinComponent {}
